function createFieldSubscribeApi(store, getFormApi, getLogger) {
  const fieldSubscribers = /* @__PURE__ */ new Set();
  function notifyFieldSubscriber(fieldName, operations) {
    const formApi = getFormApi();
    const field = formApi.getField(fieldName);
    if (field !== void 0) {
      const errors = formApi.getFieldErrors(fieldName);
      const log = getLogger();
      log("notifyFieldSubscriber", fieldName);
      fieldSubscribers.forEach(([subName, subscriber]) => {
        if (fieldName === subName) {
          subscriber(field, errors, formApi, operations);
        }
      });
    }
  }
  function notifyFieldSubscribers(fieldNames, arrayFieldOperations) {
    for (const fieldName of fieldNames) {
      const operations = arrayFieldOperations?.[fieldName];
      notifyFieldSubscriber(fieldName, operations);
    }
  }
  return { fieldSubscribers, notifyFieldSubscribers, notifyFieldSubscriber };
}
export {
  createFieldSubscribeApi
};
//# sourceMappingURL=createFieldSubscribeApi.js.map
